import React, { Component } from 'react';
import Select, {SelectOption} from '../uielements/select';
import Input from '../uielements/input';
import { Icon } from 'antd';
import request from 'superagent'

const Option = SelectOption;

export default class extends Component {
  constructor(props){
    super(props);

    const found = this.props.data.filter(data => {
      return data === this.props.value;
    });

    this.state = {
      value: this.props.value,
      data: this.props.data,
      editable: true,
      showInput: this.props.value !== '' && found.length === 0
    };
  };

  check = () => {
    this.setState({ editable: false });
    if (this.props.onChange) {
      this.props.onChange(
        this.state.value,
        this.props.columnsKey,
        this.props.index
      );
    }
  };
  edit = () => {
    this.setState({ editable: true });
  };
  render() {
    const { value, editable, data, showInput } = this.state;
    const children = data.map(d => {
      return <Option key={d}>{d}</Option>;
    });
    return (
      <div className="isoEditData">
        <div className="isoEditDataWrapper">
          { showInput ? (
            <Input
            style={{width: '100%'}}
            onChange={(event) => {
              this.setState({ value: event.target.value});
              if (this.props.onChange) {
                this.props.onChange(
                  event.target.value,
                  this.props.columnsKey,
                  this.props.index
                );
              }
            }}
            onPressEnter={this.check}
            value={value}/>
          ) : (
            <Select
              style={{width: '100%'}}
              onChange={(value) => {
                this.setState({value, showInput: value === 'info.tab.free.text'});
                if (this.props.onChange) {
                  this.props.onChange(
                    value,
                    this.props.columnsKey,
                    this.props.index
                  );
                }
              }}
              onPressEnter={this.check}
              value={value}
            >
              {children}
            </Select>
          )}
        </div>
      </div>
    );
  }
}
